import {Component, inject, Input, OnInit} from '@angular/core';
import {PropertyService} from '../../property.service';
import {PropertyImageGalleryComponent} from '../property-image-gallery/property-image-gallery.component';
import {IonButton} from '@ionic/angular/standalone';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-parent-property',
  templateUrl: './parent-property.component.html',
  styleUrls: ['../property-page.component.scss', './parent-property.component.scss'],
  imports: [
    PropertyImageGalleryComponent,
    IonButton,
    RouterLink,
    TranslateModule
  ]
})
export class ParentPropertyComponent  implements OnInit {

  @Input() parentId: string = '';
  propertyService: PropertyService = inject(PropertyService);
  imagesList: any = [];
  propertyInfo: any;
  constructor() { }

  async ngOnInit() {
    if (this.parentId) {
      this.imagesList = await this.propertyService.getPropertyImages(this.parentId);
      this.propertyInfo = await this.propertyService.getPropertyInfo(this.parentId);
    }
  }

}
